<template>
  <ol class="breadcrumb">
    <li class="breadcrumb-item" :key="index" v-for="(item, index) in list">
      <span class="active" v-if="isLast(index)">{{ showName(item) }}</span>
      <!-- <router-link :to="item" v-else>{{ showName(item) }}</router-link> -->
      <!-- 2018.05.29 수정 breadcrumb에서 대메뉴에 링크가 걸리는 부분 지우고 문자스타일 변경 -->
      <span class="active" style="font-weight:900" :to="item" v-else>{{ showName(item) }}</span>
    </li>
  </ol>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  methods: {
    isLast (index) {
      return index === this.list.length - 1
    },
    showName (item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label
      }
      if (item.name) {
        item = item.name
      }
      return item
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Breadcrumb.vue